import {View} from 'react-native';
import moment from 'moment';
import PropTypes from 'prop-types';

import sy from '~/styles';
import {Text, ServiceWarning} from '~/components/controls';
import {TIRE_PERMISSION_LABELS, TIRE_PERMISSION_SORT} from '~/types/rob';
import {SERVICE_TYPE_CODES} from '~/types/services';

const SERVICE_TYPE_SUBTITLE = {
  [SERVICE_TYPE_CODES.Maintenance]: (contract, car) => {
    if (contract?.permissions.repairAndMaintenance === false) {
      return 'Niet in contract';
    }

    let text = 'Laatst niet bekend';
    let last_service_date = null;
    if (
      contract?.last_service_request?.maintenance ||
      contract?.vehicle?.maintenance?.lastMaintenanceDate
    ) {
      let date;
      let code;

      const last_bk_maintenance_date = contract?.last_service_request
        ?.maintenance?.date
        ? moment(contract?.last_service_request?.maintenance?.date)
        : null;
      const last_rob_maintenance_date = contract?.vehicle?.maintenance
        ?.lastMaintenanceDate
        ? moment(contract?.vehicle?.maintenance?.lastMaintenanceDate)
        : null;

      if (
        !last_rob_maintenance_date ||
        last_bk_maintenance_date?.isSameOrAfter(
          last_rob_maintenance_date,
          'date',
        )
      ) {
        date = last_bk_maintenance_date;
        code = contract?.last_service_request?.maintenance?.code;
      } else {
        date = last_rob_maintenance_date;
        code = contract.leaseContract
          ? `(${contract.vehicle.maintenance.lastMaintenanceCode})`
          : '';
      }

      last_service_date = date;
      text = `Laatst bekend ${moment(date).format('DD-MM-YYYY')} ${
        code ? `(${code})` : ''
      }`;
    }

    return (
      <View style={[sy['flex-row'], sy['items-center'], sy['gap-2']]}>
        {Boolean(text) && (
          <Text style={[sy.small, sy['text-lightgray']]}>{text}</Text>
        )}
        {car && (
          <ServiceWarning
            service={{
              last: last_service_date,
              kilometrage:
                car.kilometrage -
                (contract?.last_service_request?.maintenance?.mileage ?? 0),
              ascription: car.ascription,
            }}
          />
        )}
      </View>
    );
  },

  [SERVICE_TYPE_CODES.Inspection]: (contract) => {
    if (contract?.permissions.repairAndMaintenance === false) {
      return 'Niet in contract';
    }

    return contract?.vehicle?.maintenance?.nextPeriodicCheck
      ? `Vervalt ${moment(
          contract?.vehicle?.maintenance?.nextPeriodicCheck,
        ).format('DD-MM-YYYY')}`
      : null;
  },

  [SERVICE_TYPE_CODES.Tires]: (contract) => {
    const allowed = [];
    const denied = [];

    Object.keys(contract?.permissions.tires ?? {})
      .filter((item) => TIRE_PERMISSION_LABELS[item])
      .sort(
        (a, b) =>
          TIRE_PERMISSION_SORT.indexOf(a) - TIRE_PERMISSION_SORT.indexOf(b),
      )
      .forEach((item) => {
        if (contract.permissions.tires[item]) {
          allowed.push(TIRE_PERMISSION_LABELS[item]);
        } else {
          denied.push(TIRE_PERMISSION_LABELS[item]);
        }
      });

    let text;
    if (denied.length === 0) {
      text = allowed.join(', ');
    } else if (allowed.length === 0) {
      text = `${denied.join(', ')} niet in contract`;
    } else {
      text = `${allowed.join(', ')} (${denied.join(', ')} niet in contract)`;
    }

    if (!text) {
      return null;
    }

    return text.charAt(0).toUpperCase() + text.slice(1);
  },
};

const ServiceTypeSubtitle = ({type, contract, car}) =>
  SERVICE_TYPE_SUBTITLE[type]?.(contract, car) ?? null;

ServiceTypeSubtitle.propTypes = {
  type: PropTypes.string,
  contract: PropTypes.object,
  car: PropTypes.object,
};

export default ServiceTypeSubtitle;
